import PropTypes from 'prop-types'
import React, { Fragment, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import Util from "./Common/Util"

import moment from 'moment';

// import images
import client from "../../assets/images/client.png";
import transactionAmount from "../../assets/images/transactionAmount.png";
import transactionPrice from "../../assets/images/transactionPrice.png";
import tradeHistory from "../../assets/images/거래내역.jpg";
import news from "../../assets/images/news.jpg";

// Charts
import LineAreaChart from "../AllCharts/apex/lineareachart";
import ChartistGraph from 'react-chartist';

import "chartist/dist/scss/chartist.scss";

import { useSelector } from 'react-redux';
import defaultImg from "../../assets/images/default.png"

import { dashboardResponse, mainResponse, newsResponse, postProcessingWearing, postWaste, postWearing } from 'crud/auth.crud';
import { useEffect } from 'react';

const initDashboardItem = [
  {text: '전일 총 수거량', value: 0, unit: 'ℓ'},
  {text: '금월 총 수거량', value: 0, unit: 'ℓ'},
  {text: '전일 수거 정산금액', value: 0, unit: '원'},
  {text: '금월 수거 정산금액', value: 0, unit: '원'},
  {text: '전일 총 인계량', value: 0, unit: 'ton'},
  {text: '금월 총 인계량', value: 0, unit: 'ton'},
  {text: '금월 미정산 금액', value: 0, unit: '원', box: true},
  {text: '전월 미정산 금액', value: 0, unit: '원', box: true},
]

const initVehicleItem = [
  {driver: '000', correspondent: 0, settlement: 10000000, todayCollection: 1000, yesterdayCollection: 10000, state: 'Y', carNumber: '00가 0000'},
  {driver: '000', correspondent: 0, settlement: 10000000, todayCollection: 1000, yesterdayCollection: 10000, state: 'Y', carNumber: '00가 0000'},
  {driver: '000', correspondent: 0, settlement: 10000000, todayCollection: 1000, yesterdayCollection: 10000, state: 'Y', carNumber: '00가 0000'},
  {driver: '000', correspondent: 0, settlement: 10000000, todayCollection: 1000, yesterdayCollection: 10000, state: 'N', carNumber: '00가 0000'},
]

const initWaverbarItem = [
  {state: 'Y'},
  {state: 'Y'},
  {state: 'N'},
  {state: 'E'},
]

const collectionItem = [
  {text: '운반기사', key: 'driver', unit: ''},
  {text: '거래처 수', key: 'correspondent', unit: ''},
  {text: '수거 정산금액', key: 'settlement', unit: '원'},
  {text: '금일 수거량', key: 'todayCollection', unit: 'L'},
  {text: '전일 수거량', key: 'yesterdayCollection', unit: 'L'},
]
 
const carBadge = {
  Y: {text: '운행중', class: 'primary-bg'},
  N: {text: '미운행', class: 'light-bg'},
  E: {text: '이상발생', class: 'error-bg'}
}
 
const waverbarBadge = {
  Y: {text: '정상', class: 'primary-bg'},
  N: {text: '비활성', class: 'light-bg'},
  E: {text: '이상발생', class: 'error-bg'}
}

const Emitter = props => {
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()
  const history = useHistory()

  const [fixedYear, setfixedYear] = useState(moment(newDate).format("YYYY")) //최신으로 고정되는 년도값
  const [page, setPage] = useState(1)
  const [companyCount, setCompanyCount] = useState();
  const [collectSum, setCollectSum] = useState();
  const [collectMoneySum, setCollectMoneySum] = useState();
  const [newsList, setNewsList] = useState();
  const [thisMonth, setThisMonth] = useState() //이달의 배출량
  const [prevMonth, setPrevMonth] = useState() //저번달의 배출량
  const [user, setUser] = useState(selector.auth?.user)
  const [myCollectSum, setMyCollectSum] = useState(0)
  const [startDate, setStartDate] = useState(moment(newDate).format('YYYY-MM-DD') + ' 00:00:00')
  const [endDate, setEndDate] = useState(moment(nextDate.setDate(nextDate.getDate() + 1)).format('YYYY-MM-DD') + ' 00:00:00')
  const [detailType, setDetailType] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]?.type || "")
  const [dashboardItem, setDashboardItem] = useState(initDashboardItem)
  const [vehicleItem, setVehicleItem] = useState(initVehicleItem)
  const [waverbarItem, setWaverbarItem] = useState(initWaverbarItem)

  const getDataList = async () => {
    try {
      const params = {
        company: user.member_group?.[0]?.company_group?.id,
        start_ym: startDate,
        end_ym: endDate,
      }
      let url = '/waste_collect/emitter_collect_sum/';
      if (detailType === 'multi') {
        url = '/waste_collect/emitter_multi_collect_sum/'
      } else if (detailType === 'total') {
        url = '/waste_collect/emitter_total_collect_sum/'
      }
      const response = await postWaste(url, params);
      if (response.data?.result === 'success') {
        const myCollectSum = response?.data?.data || 0;
        setMyCollectSum(myCollectSum)
      }
    } catch (error) {
      console.error(error);
    }
  }

  // 지금 이 시간 웨이스트버스는? 가져오는 용
  const getDashboardData = async () => {
    const response = await dashboardResponse();
    if (response.data?.result === 'success') {
      const item = response.data?.data
      setCompanyCount(Util.setAbbreviation(item.company_count));
      setCollectSum(Util.setAbbreviation(item.sum_collect));
      setCollectMoneySum(Util.setAbbreviation(item.sum_collect_money));
    }
  }

  // 웨이스트버스뉴스! 가져오는 용
  const getNewsList = async () => {
    try {
      const response = await newsResponse();
      if (response.status === 200) {
        const tmpData = response.data?.results?.sort((a, b) => new Date(b.write_date).getTime() - new Date(a.write_date).getTime());
        const newsList = tmpData?.slice(0, 9).map(news => ({
          ...news,
          write_date: moment(new Date(news.write_date)).format('YYYY-MM-DD HH:mm:ss'),
          subject: Util.truncateString(Util.replaceHtmlTag(news.subject), 120),
          content: Util.truncateString(Util.replaceHtmlTag(news.content), 80),
        }));
        setNewsList(newsList);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getNewsList();
    getDashboardData();
    getDataList()
  }, [])

  return (
    <Fragment>
      <Row>
        {dashboardItem.map((item, index) => (
          <Col xs={12} md={6} lg={6} xl={3} key={'dashboard_item_'+index}>
            <Card style={{ height: 150 }} className='position-relative box-border'>
              {item.box &&
                <div className='unsettled-box error-bg white-text'>3</div>
              }
              <CardBody className='d-flex flex-direction-column'>
                <Row>
                  <Col>
                    <p className='font-size-18 primary-text font-weight-bold'>{item.text}</p>
                  </Col>
                </Row>
                <Row className='justify-content-end mt-auto'>
                  <p className='fit-content mb-0 font-size-50 font-weight-800'>{Util.setCommaPrice(item.value)}<span className='font-size-18'> {item.unit}</span></p>
                </Row>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <div className='margin-top-48'>
        <p className='font-size-16'>■ 차량별 수거 현황</p>
      </div>
      
      <Row>
        {vehicleItem.map((item, index) => (
          <Col xs={12} md={6} lg={6} xl={3} key={'vehicle_item_'+index}>
            <Card style={{ height: 246 }} className='position-relative box-border'>
              <div className={`vehicle-box ${carBadge[item.state].class} white-text`}>{carBadge[item.state].text}</div>
              <CardBody className='d-flex flex-direction-column padding-left-21 padding-top-18'>
                <Row>
                  <Col>
                    <p className='font-size-18 primary-text font-weight-bold margin-bottom-40'>{index + 1}호차({item.carNumber})</p>
                  </Col>
                </Row>
                {collectionItem.map((colItem, colIndex) => (
                  <p key={'collection_item_'+colIndex} className='fit-content mb-0 font-size-16'>- &emsp; {colItem.text} : {Util.setCommaPrice(item[colItem.key])} {colItem.unit}</p>
                ))}
              </CardBody>
            </Card> 
          </Col>
        ))}
      </Row>
      
      <Row>
        {waverbarItem.map((item, index) => (
        <Col xs={12} md={6} lg={6} xl={3}>
          <Card className='box-border'>
            <CardBody className='d-flex flex-direction-column'>
              <div className='d-flex justify-content-between'>
                <p className='mb-0 font-size-18'>웨버바 Crnsd...</p>
                <div className='badge-normal padding-left-16 padding-right-16 padding-top-4 padding-bottom-4'>정상</div>
              </div>
            </CardBody>
          </Card>
        </Col>
        ))}
      </Row>
    </Fragment>
  )
}

export default Emitter